// List of components we don't want to render on CC-UI
export const UnsupportedComponentTypes = [
  'cod-only',
  'cod-with-clr',
  'id-at-cod',
  'cod-version-36',
  'cod-dy-suggestions',
  'dy-recommendations',
];

// List of components we cannot edit on CC-UI
export const NonEditableComponentTypes = [
  'image',
  'fr-legacy-cod-screen',
  'fr-legacy-route-plv-promos',
  'fr-ngcod-cod',
  'fr-plv-promo',
  'fr-takeover-promo',
  'fr-banner-promo',
  'fr-suggestion',
  'fr-recommendation',
  'fr-arrows-fullscreen',
  'hj-cod',
  'hj-legacy-playlist',
  'flex-component',
];

export enum ComponentTypes {
  SINGLE_SHELF = 'single-shelf',
  PROMOTIONAL_SPACE = 'promotional-space',
  PROMOTIONAL_COMPONENT = 'promotional-component',
  LISTING_WITH_OPTIONAL_VISUALS = 'listing-with-optional-visuals',
  COMBO_STYLE = 'combo-style',
  LISTING_VISUALS_GALLERY = 'listing-visuals-gallery',
  DISCLAIMER = 'disclaimer',
  COD = 'cod',
  COD_THANK_YOU = 'cod-thank-you',
  DOUBLE_SHELF = 'double-shelf',
  CONTINUOUS_SHELF = 'continuous-shelf',
  LISTING_AND_VISUALS = 'listing-and-visuals',
  PRICE_LISTING = 'price-listing',
  SINGLE_PRODUCT_LISTING = 'single-product-listing',
  SINGLE_LISTING_NO_VISUAL = 'single-listing-no-visual',
  TWO_PRODUCT_LISTING = 'two-product-listing',
}

// List of component fields to omit when extracting asset files
export const ComponentConfigImageFields = [
  'background',
  'assetName',
  'image',
  'icon',
  'value',
];
